<h2 style="color: #004F71">Alternate Variations</h2>
<div class="dialog-content">
  @if (groupedVariations.length) {
    <mat-accordion [multi]="true">
      @for (group of groupedVariations; track trackByVariation($index, group)) {
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ group.variationLabel }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <table mat-table [dataSource]="group.rows" class="variations-table">
            <ng-container matColumnDef="attribute">
              <th mat-header-cell *matHeaderCellDef><b>Attribute</b></th>
              <td mat-cell *matCellDef="let row">{{ row.attribute }}</td>
            </ng-container>
            <ng-container matColumnDef="baseValue">
              <th mat-header-cell *matHeaderCellDef><b>Base Value</b></th>
              <td mat-cell *matCellDef="let row">{{ row.baseValue }}</td>
            </ng-container>
            <ng-container matColumnDef="override">
              <th mat-header-cell *matHeaderCellDef><b>Modified Value</b></th>
              <td mat-cell *matCellDef="let row">{{ row.override }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['attribute', 'baseValue', 'override']; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: ['attribute', 'baseValue', 'override'];"></tr>
          </table>
        </mat-expansion-panel>
      }
    </mat-accordion>
  } @else {
    <p>There are no overrides to display</p>
  }
</div>
